module.exports = __webpack_public_path__ + "static/media/collaboration.80ce6207.svg";